export const Events = {
  Open: 'concord-widget-open',
  Opened: 'concord-widget-opened',
  Close: 'concord-widget-close',
  Closed: 'concord-widget-closed',
  Toggle: 'concord-widget-toggle',
  ToggleConsent: 'concord-widget-toggle-consent',
};
